export const checkStatus = (jobId: string) =>
  `/api/background_job_statuses/${jobId}`;
